import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromGetPreviousDirectorsActions } from '../actions';
import { IGetDirectorsPreviousResponse } from '../models/get-directors.model';

export const previousDirectorsAndAdminsFeatureKey = 'previousDirectorsAndAdmins';

export interface State {
  loadGetPreviousDirectorsAndAdminsResponse: IGetDirectorsPreviousResponse[];
  loadGetPreviousDirectorsAndAdminsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: State = {
  loadGetPreviousDirectorsAndAdminsResponse: undefined,
  loadGetPreviousDirectorsAndAdminsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(fromGetPreviousDirectorsActions.loadPreviousDirectorsAndAdminssSuccess, (state, action) => ({
    ...state,
    loadGetPreviousDirectorsAndAdminsResponse: action.response,
    loaded: true
  })),
  on(fromGetPreviousDirectorsActions.loadPreviousDirectorsAndAdminssFailure, (state, action) => ({
    ...state,
    loadGetPreviousDirectorsAndAdminsFailure: action.error,
    loaded: true
  }))
);

export const getPreviousDirectorsResponse = (state: State) => state.loadGetPreviousDirectorsAndAdminsResponse;
export const getPreviousDirectorsIsLoaded = (state: State) => state.loaded;
